import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { apiClient } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminBlog() {
  const [posts, setPosts] = useState([]);

  const fetchPosts = () => apiClient.get("/admin/blog").then((res) => setPosts(res.data));
  useEffect(() => { fetchPosts(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this article?")) return;
    await apiClient.delete(`/admin/blog/${id}`);
    toast.success("Article deleted");
    fetchPosts();
  };

  return (
    <div data-testid="admin-blog-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-display font-semibold text-slate-900">Research Library</h1>
        <Link to="/admin/blog/new"><Button size="sm" className="rounded-md" data-testid="admin-new-blog-btn"><Plus className="h-4 w-4 mr-1.5" /> New Article</Button></Link>
      </div>
      <div className="bg-white border border-slate-200 rounded-md shadow-sm divide-y divide-slate-100">
        {posts.map((p) => (
          <div key={p.id} className="flex items-center justify-between px-4 py-3" data-testid={`admin-blog-row-${p.slug}`}>
            <div>
              <p className="text-sm font-medium text-slate-900">{p.title}</p>
              <p className="text-xs text-slate-500">{p.published ? "Published" : "Draft"} &middot; {new Date(p.created_at).toLocaleDateString()}</p>
            </div>
            <div className="flex gap-2">
              <Link to={`/admin/blog/${p.id}/edit`}><Button size="sm" variant="outline" data-testid={`admin-edit-blog-${p.slug}`}><Pencil className="h-3.5 w-3.5" /></Button></Link>
              <Button size="sm" variant="outline" onClick={() => handleDelete(p.id)} data-testid={`admin-delete-blog-${p.slug}`}><Trash2 className="h-3.5 w-3.5 text-red-500" /></Button>
            </div>
          </div>
        ))}
        {posts.length === 0 && <p className="p-6 text-center text-slate-400 text-sm" data-testid="admin-no-blog-posts">No articles yet.</p>}
      </div>
    </div>
  );
}
